module.exports = "<figure class=\"figure-full\">\n  <img class=\"absolute-full\"  src=\"https://tractorzoom.com/assets/pages/img/homepage2.png\"/>\n</figure>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/figure-full/figure-full.component.html
// module id = ./src/app/components/figure-full/figure-full.component.html
// module chunks = main